/*eslint-disable */
/**
 * @copyright    Copyright © 2019-2025 MiniVentureLab
 * @author       Shubham Shukla  <shukla@gide.ai>
 * @package      Gide
 * @license      Proprietary
 * @description  AES encrypt and dcrypt functionality
 *
 *
 */

import CryptoJS from 'crypto-js';

let encryptAndDecrypt = {
  /**
   * aes_encrypt
   */
  aes_encrypt(key, data) {
    key = key+process.env.VUE_APP_AES_SALT;
    return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
  },

  /*
   * aes_decrypt
   */
  aes_decrypt(key, data) {
    key = key+process.env.VUE_APP_AES_SALT;
    var bytes  = CryptoJS.AES.decrypt(data, key);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
  },

  /*
  * decrypt PII Data
  */
  async decryptPIIData(user_id, userRespObj) {
    try {
      if (userRespObj.user_mobile) {
        userRespObj.user_mobile = await encryptAndDecrypt.aes_decrypt(user_id, userRespObj.user_mobile)
      }

      if (userRespObj.user_email) {
        userRespObj.user_email = await encryptAndDecrypt.aes_decrypt(user_id, userRespObj.user_email)
      }

      if (userRespObj.parent_email) {
        userRespObj.parent_email = await encryptAndDecrypt.aes_decrypt(user_id, userRespObj.parent_email)
      }

      if (userRespObj.parent_mobile) {
        userRespObj.parent_mobile = await encryptAndDecrypt.aes_decrypt(user_id, userRespObj.parent_mobile)
      }

      if (userRespObj.parent_email_list) {
        userRespObj.parent_email_list = await encryptAndDecrypt.aes_decrypt(user_id, userRespObj.parent_email_list)
      }

      return userRespObj
    }
    catch (e) {
      console.error("decryptPIIData: Ex:", e)
    }
  }
}

export default encryptAndDecrypt;